<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Отправить сообщение',
                        url: '/telegram/chats'
                    },
                    {
                        title: 'Настроить чаты',
                        url: '/telegram/chats/settings'
                    },
                ]
            }
        }
    }
</script>
